import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Isvg from 'react-inlinesvg';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { memberStatus as memberStatusEnum } from 'enums/memberStatus';
import { memberStatus as memberStatusSelector } from 'redux/saga/selectors/user';
import { decorateWith, withName } from 'helpers/decorator';

export const mapStateToProps = state => ({
  isActive: memberStatusEnum('ACTIVE', memberStatusSelector(state)),
});

export const GiftLinkUnwrapped = ({ isActive }) => (
  <li
    className={classNames('header__gifts', {
      'header__gifts--attention': isActive,
    })}>
    <Link to="/gifts?ref=header_click">
      <FormattedMessage id="header.link.gifts" defaultMessage="Gifts" />
      {isActive && <Isvg key="gift-green" className="svg" src={require('static/img/icon/gift-green.svg')} />}
    </Link>
  </li>
);

GiftLinkUnwrapped.propTypes = {
  isActive: PropTypes.bool.isRequired,
};

export const GiftLink = decorateWith(connect(mapStateToProps), withName('GiftLink'))(GiftLinkUnwrapped);
